import { render, staticRenderFns } from "./CompleteConversationReservation.vue?vue&type=template&id=ef3cfea4&scoped=true&"
import script from "./CompleteConversationReservation.vue?vue&type=script&lang=js&"
export * from "./CompleteConversationReservation.vue?vue&type=script&lang=js&"
import style0 from "./CompleteConversationReservation.vue?vue&type=style&index=0&id=ef3cfea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3cfea4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VMain,VRow})
